import type { ProductGroup, Product } from '~/common/model/capabilities'

export type GroupedProducts = Partial<Record<ProductGroup, Product[]>>

export const getSortedProductGroups = (groupedProducts: GroupedProducts, isCCC: boolean): ProductGroup[] => {
  const keys = Object.keys(groupedProducts) as ProductGroup[]

  if (isCCC) {
    return keys.sort()
  } else {
    // First sort by postfix EU DESC
    keys.sort((a, b) => {
      if (a.endsWith('EU') && !b.endsWith('EU')) {
        return 1
      }
      if (!a.endsWith('EU') && b.endsWith('EU')) {
        return -1
      }
      return 0
    })
    // Then sort by prefix Consumer ASC
    keys.sort((a, b) => {
      if (a.startsWith('Consumer') && !b.startsWith('Consumer')) {
        return -1
      }
      if (!a.startsWith('Consumer') && b.startsWith('Consumer')) {
        return 1
      }
      return 0
    })
    return keys
  }
}
